import { Color } from 'theme/style'

const style = {
  root: {
    borderRadius: '25px',
    transition: 'all 0.2s',
    height: '50px',
    letterSpacing: '0.6px',
  },
  contained: {
    padding: '10px 15px',
    textTransform: 'uppercase',
    fontWeight: 700,
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
  },
  containedPrimary: {
    color: Color.White
  },
  text: {
    padding: '6px 20px'
  }
};

export default style